/* unplugin-vue-components disabled */import { render } from "./QuizSimpleTextQuestion.vue?vue&type=template&id=d42ba51c&scoped=true&ts=true"
import script from "./QuizSimpleTextQuestion.vue?vue&type=script&lang=ts"
export * from "./QuizSimpleTextQuestion.vue?vue&type=script&lang=ts"

import "./QuizSimpleTextQuestion.vue?vue&type=style&index=0&id=d42ba51c&scoped=true&lang=scss"
import "./QuizSimpleTextQuestion.vue?vue&type=style&index=1&id=d42ba51c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d42ba51c"]])

export default __exports__